import { render, staticRenderFns } from "./RvGroupDetail.vue?vue&type=template&id=b504a25e&scoped=true"
import script from "./RvGroupDetail.vue?vue&type=script&lang=js"
export * from "./RvGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./RvGroupDetail.vue?vue&type=style&index=0&id=b504a25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b504a25e",
  null
  
)

export default component.exports